import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';

import { BUYER_USER, UPDATE_BUYER_USER } from './queries';
import { ButtonContainer } from './elements';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EditBuyerUser = ({setShowModal, refetch, buyerUser }) => {
  const [submitting, setSubmitting] = useState();
  const [updateBuyerUser] = useMutation(UPDATE_BUYER_USER, {
    onCompleted: () => {
      console.log("REFECTH:", refetch);
      if (refetch) { refetch(); console.log("REFETCH CALLED"); }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    updateBuyerUser({ variables: input });
  });

  const { control, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      id: buyerUser?.id,
      firstName: buyerUser?.firstName || '',
      lastName: buyerUser?.lastName || '',
      email: buyerUser?.email || '',
      role: buyerUser?.role || '',
    }
  });

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Email is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "Email should have at most 50 characters",
                matchPattern: (v) => EMAIL.test(v) ||
                  "Must be a valid email address",
              },
            })}
          />
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Role:"
            name="role"
            options={[
              { value: 'Admin', label: 'Admin' },
              { value: 'Normal', label: 'Normal' },
            ]}
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Buyer User" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditBuyerUser;
